<template>
  <div
    class="height-100 width-100"
    style="overflow: hidden;">
    <div class="history-header">
      <div
        class="history-title"
        data-qa="chat-title">
        <slot name="title"/>
      </div>
    </div>
    <div
      ref="chatItems"
      class="history-items"
      :class="{'with-chat': chat}"
      data-qa="chat-items"
      :style="itemsHeight">
      <slot name="items"/>
    </div>
    <template
      v-if="chat && $slots.chatInput">
      <slot
        name="chatInput"/>
    </template>
    <sChatInput
      v-else-if="chat && !$slots.chatInput"
      class="width-100 history-footer"
      :disabled="disabled || loading"
      :file-count="files ? files.length : 0"
      :file-show="fileShow"
      :files.sync="modalFiles"
      :loading="loading"
      :value.sync="textMutable"
      @addFile="fileModalShow = true"
      @resize="resize"
      @send="value => $emit('send', value)">
      <template
        v-slot:afterInput>
        <slot
          name="afterInput"/>
      </template>
      <template
        v-slot:beforeInput>
        <slot
          name="beforeInput"/>
      </template>
    </sChatInput>
    <ModalDocumentAdd
      :files.sync="modalFiles"
      :loading="loading"
      :multiple="false"
      :show.sync="fileModalShow"/>
  </div>
</template>
<script>
import ModalDocumentAdd from 'components/common/blocks/history/ModalDocumentAdd.vue'
/**
 * Шаблон для чатов
 */
export default {
  name: 'chatTemplate',
  data() {
    return {
      fileModalShow: false,
      itemsHeight: ''
    }
  },
  props: {
    text: String,
    /**
     * активность строки ввода текста
     */
    disabled: {
      type: Boolean
    },
    /**
     * Признак загрузки
     */
    loading: {
      type: Boolean
    },
    /**
     * Отображение строки ввода текста
     */
    chat: {
      type: Boolean
    },
    /**
     * Доступность загрузки файлов
     */
    fileShow: {
      type: Boolean
    },
    /**
     * Файлы вопроса/обращения и т.п.
     */
    files: {
      type: Array
    }
  },
  methods: {
    resize(val) {
      this.$nextTick(() => {
        const itemtop = this.$refs.chatItems.offsetTop
        const maxHeight = document.documentElement.offsetHeight / 2

        let height = val > maxHeight ? maxHeight : val
        if (this.chat) {
          this.itemsHeight = `height: calc(100% - ${itemtop}px - ${height + 51}px);`
        } else {
          return 'height: calc(100% - 70px);'
        }
      })
    },
  },
  computed: {
    textMutable: {
      get () {
        return this.text
      },
      set (newValue) {
        this.$emit('update:text', newValue)
      }
    },
    modalFiles: {
      get () {
        return this.files
      },
      set (newValue) {
        this.$emit('update:files', newValue)
      }
    }
  },
  watch: {
    chat: {
      immediate: true,
      handler(value) {
        this.itemsHeight = `height: calc(100% - 70px${value ? ' - 96px' : ''});`
      }
    }
  },
  components: {
    ModalDocumentAdd
  }
}
</script>
<style scoped>
.history-header {
  background: var(--v-secondary__green_chosen-base);
  height: 70px;
  border-radius: 6px 6px 0 0;
  border-bottom: 2px solid var(--color-main-green);
  padding: 20px 20px;
  overflow: hidden;
}
.history-title {
  display: flex;
  margin: auto 0;
  font-weight: 600;
}
.history-items {
  overflow: auto;
  background: var(--v-main__light_green-base);
  height: calc(100% - 70px);
  border-radius: 0 0 6px 6px;
}
.history-items.with-chat {
  /*height: calc(100% - 70px - 69px);*/
  position: relative;
  border-radius: 0 0 0 0;
}
.history-footer {
  position: relative;
  border-top: 2px solid var(--color-main-green);
  padding: 10px 10px 5px 10px;
  width: 100%;
  z-index: 1;
  background: var(--v-main__light_green-base);
}
::v-deep .file-modal .s-modal-header {
  height: 0;
}
::v-deep .import-block .v-card__actions {
  padding-top: 0px !important;
}
</style>
